import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'LinearLoader',
  props: ['loading'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("progress", {
    class: _normalizeClass(["pure-material-progress-linear q-position-absolute", {'show': __props.loading}])
  }, null, 2))
}
}

})